/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CustomerActivityOverview extends JSONable {

  actualCompletionDate: string | undefined = undefined;
  plannedStartDate: string | undefined = undefined;
  startTime: string | undefined = undefined;
  endTime: string | undefined = undefined;
  activityStatus: string | undefined = undefined;
  comments: string | undefined = undefined;
  activityType: string | undefined = undefined;
  activityObjetive: string | undefined = undefined;
  activityPurpose: string | undefined = undefined;
  createdBy: string | undefined = undefined;
}
